import { render, staticRenderFns } from "./c_title.vue?vue&type=template&id=201c36db&scoped=true"
import script from "./c_title.vue?vue&type=script&lang=js"
export * from "./c_title.vue?vue&type=script&lang=js"
import style0 from "./c_title.vue?vue&type=style&index=0&id=201c36db&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201c36db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/yunxiao/be-3sdnltdmmjqei95chipgpfz5/runner/__flow_work/__flow_builds/182a3969-2a32-4dff-94d8-cf1bbedf203a/workspace/crmeb-mer-admin_BNnv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('201c36db')) {
      api.createRecord('201c36db', component.options)
    } else {
      api.reload('201c36db', component.options)
    }
    module.hot.accept("./c_title.vue?vue&type=template&id=201c36db&scoped=true", function () {
      api.rerender('201c36db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_title.vue"
export default component.exports